import { doc, DocumentReference } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';

export interface ISelectedEntitySettings {
  athleteId: string;
  teamId: string;
  groupId: string;
}

/**
 * @description observes dashboard settings
 */

export const selectedEntitySettingsProvider =
  (): Observable<ISelectedEntitySettings> => {
    return authenticatedUserProvider().pipe(
      switchMap((user: IUser): Observable<ISelectedEntitySettings> => {
        return docData(
          doc(
            user.services.firestore,
            `userProfiles/${user.id}/settings/selectedEntities`
          ) as DocumentReference<ISelectedEntitySettings>
        );
      })
    );
  };
